export enum CountrySearchAmount {
    First,
    Second
}